import { LessonProgressCard } from '@/components/lesson/LessonProgressCard';
import UnitLessonCard from '@/components/lesson/UnitLessonCard';
import LessonProgressDashboardStats from '@/models/LessonProgressDashboardStats';
import { toStudentLessonItems } from '@/utils/lesson/lessonItems';
import { LessonNameFormatter } from '@/utils/lesson/nameFormatterFactory';
import { CourseRoute } from '@/utils/routes';

type UnitLessonProgressItemProps = CourseRoute & {
  lessonProgress: LessonProgressDashboardStats;
  lessonNameFormatter: LessonNameFormatter;
};

export default function UnitLessonProgressItem({
  lessonProgress,
  lessonNameFormatter: { formatName },
  ...route
}: UnitLessonProgressItemProps) {
  const { lesson, progress } = lessonProgress;

  return (
    <UnitLessonCard
      {...route}
      lesson={lesson}
      name={formatName(lesson)}
      items={toStudentLessonItems(lessonProgress)}
      highlighted={progress > 0 && progress < 1}
    >
      <LessonProgressCard.Progress progress={progress} />
    </UnitLessonCard>
  );
}
